var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9058 1.83337H5.09405C2.83716 1.83337 1.33325 3.44664 1.33325 5.76215V11.2379C1.33325 13.5556 2.8332 15.1667 5.09405 15.1667H10.9058C13.1666 15.1667 14.6666 13.5556 14.6666 11.2379V5.76215C14.6666 3.44448 13.1666 1.83337 10.9058 1.83337ZM5.09408 2.76355H10.9058C12.6375 2.76355 13.7364 3.9439 13.7364 5.7621V11.2379C13.7364 13.0561 12.6375 14.2364 10.9058 14.2364H5.09408C3.36243 14.2364 2.26351 13.0561 2.26351 11.2379V5.7621C2.26351 3.94632 3.3661 2.76355 5.09408 2.76355ZM8.48445 5.28592C8.45365 5.05889 8.25905 4.88391 8.02358 4.88391C7.76671 4.88391 7.55847 5.09215 7.55847 5.34903V11.6391L7.56271 11.7022C7.59351 11.9292 7.78811 12.1042 8.02358 12.1042C8.28046 12.1042 8.4887 11.896 8.4887 11.6391V5.34903L8.48445 5.28592ZM5.59039 7.32174C5.55959 7.09472 5.36499 6.91974 5.12952 6.91974C4.87264 6.91974 4.6644 7.12798 4.6644 7.38486V11.6392L4.66865 11.7023C4.69945 11.9293 4.89405 12.1043 5.12952 12.1043C5.38639 12.1043 5.59463 11.8961 5.59463 11.6392V7.38486L5.59039 7.32174ZM10.8704 9.16792C11.1058 9.16792 11.3004 9.3429 11.3312 9.56993L11.3355 9.63304V11.6393C11.3355 11.8961 11.1272 12.1044 10.8704 12.1044C10.6349 12.1044 10.4403 11.9294 10.4095 11.7024L10.4053 11.6393V9.63304C10.4053 9.37616 10.6135 9.16792 10.8704 9.16792Z",
    fill: "white",
    fillOpacity: 0.73
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.7d6fcc10.svg";
export { ForwardRef as ReactComponent };